import React, { useEffect } from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { authSelector, checkUserToken, clearUserTokenVar } from '../../Auth/authSlice';
import PrivateRoute from '../PrivateRoute';
// import Dashboard from '../../CHDPanel/Dashboard/index';
// import FrontAllProcess from '../../CHDPanel/Process/index';
// import FrontViewAllUser from '../../CHDPanel/ViewAllUser/index';
// import FrontViewProcess from '../../CHDPanel/ViewAllProcess/index';
// import Notification from '../../CHDPanel/Notification/index';
import Dashboard from '../../CHDPanel/Dashboard/index';
import FrontAllProcess from '../../CHDPanel/Process/index';
import kivProcess from '../../CHDPanel/Process/kiv/index';
import FrontViewAllUser from '../../CHDPanel/ViewAllUser/index';
import FrontViewProcess from '../../CHDPanel/ViewAllProcess/index';
import Notification from '../../CHDPanel/Notification/index';
import ManageTemplates from '../../CHDPanel/Templates/index';
import ViewTemplate from '../../CHDPanel/ViewTemplates/index';
import NewTemplate from '../../CHDPanel/NewTemplate/index';
import EditTemplate from '../../CHDPanel/EditTemplate/index';
import EditTemplateDraft from '../../CHDPanel/EditTemplateDraft/index';

import AddDocument from '../../CHDPanel/AddDocument/index';
import DocumentVerification from '../../DocumentVerification/DocumentVerification';
import DocumentVerification2 from '../../DocumentVerification/DocumentVerification2';
import DocumentSignature from '../../DocumentSignature/index';
import TakeActionNotification from '../../CHDPanel/TakeActionNotification/index'
import ability from '../../../config/ability';
import AddMultipleProcessDocument from '../../CHDPanel/AddMultipleProcessDocument';
import DocumentEditor from '../../DocumentEditor/DocumentEditor';
import CollaborateDocument from '../../CHDPanel/CollaborateDocument/index';
import CommonEditor from '../../CollaborationDocumentEditor/CommonEditor';
export default function CHDRoutes() {
  const dispatch = useDispatch();
  let history = useHistory();
  const { isLoggedIn, user, isTokenValid } = useSelector(
    authSelector
  );
  useEffect(() => {
    dispatch(checkUserToken()).then((res) => {
      if (res.message === "unauthorized") { history.push('/'); }
    }).catch((err) => {
      // console.log("err=>   ", err)
    });
  }, [])

  return (
    <>
      {user.userType == 'CHD'
        ? <>
          <PrivateRoute path="/dashboard" component={Dashboard} />
          <PrivateRoute path="/all-process" component={FrontAllProcess} exact />
          <PrivateRoute path="/view-all-users" component={FrontViewAllUser} exact />
          <PrivateRoute path="/view-process" component={FrontViewProcess} exact />
          <PrivateRoute path="/kiv-process" component={kivProcess} exact />
          <PrivateRoute path="/view-all-notification" component={Notification} exact />
          <PrivateRoute path="/manage-seen-stamp" component={ManageTemplates} exact />
          <PrivateRoute path="/view-template" component={ViewTemplate} exact />
          <PrivateRoute path="/new-seen-stamp" component={NewTemplate} exact />
          <PrivateRoute path="/edit-seen-stamp" component={EditTemplate} exact />
          <PrivateRoute path="/edit-seen-stamp-draft" component={EditTemplateDraft} exact />
          <PrivateRoute path="/add-document" component={AddDocument} exact />
          <PrivateRoute path="/use-this-document" component={AddMultipleProcessDocument} exact />
          <PrivateRoute path="/verify-document" component={DocumentVerification} exact />
          <PrivateRoute path="/verify-document2" component={DocumentVerification2} exact />
          <PrivateRoute path="/document-editor" component={DocumentEditor} exact />
          <PrivateRoute path="/document-signin" component={DocumentSignature} exact />
          <PrivateRoute path="/take-action-notification" component={TakeActionNotification} exact />
          <PrivateRoute path="/draft-document" component={CollaborateDocument} exact />
          <PrivateRoute path="/new-document" component={CommonEditor} exact />

          {/* <PrivateRoute path="/dashboard" component={Dashboard} />
    <PrivateRoute path="/all-process" component={FrontAllProcess} exact />
    <PrivateRoute path="/view-all-users" component={FrontViewAllUser} exact />
    <PrivateRoute path="/view-process" component={FrontViewProcess} exact />
    <PrivateRoute path="/view-all-notification" component={Notification} exact /> */}
        </>
        : <Redirect to="/login" />
      }

    </>
  );
}


